import { useCallback, useEffect } from 'react'
import { useBeforeUnload, useBlocker } from 'react-router-dom'

const UNSAVED_CHANGES_MESSAGE = 'You have unsaved changes. Leave anyway?'

export function useUnsavedChangesGuard(enabled: boolean): void {
  useBeforeUnload(
    useCallback(
      (event) => {
        if (!enabled) return
        event.preventDefault()
        event.returnValue = UNSAVED_CHANGES_MESSAGE
      },
      [enabled]
    )
  )

  const blocker = useBlocker(enabled)

  useEffect(() => {
    if (blocker.state !== 'blocked') return
    if (window.confirm(UNSAVED_CHANGES_MESSAGE)) {
      blocker.proceed()
      return
    }
    blocker.reset()
  }, [blocker])
}
